<template>
  <div class="py-5">
    <b-row>
      <b-col md="6" xl="4" offset-md="3" offset-xl="4">
        <router-link :to="{ name: 'scan' }" class="btn btn-default w-100 p-5">
          <b-row>
            <b-col cols="8" class="text-left">
              <h4>{{ $t("actions.to_scan") }}</h4>
            </b-col>
            <b-col cols="4" class="text-right">
              <i class="fs-32 fas fa-chevron-circle-right" />
            </b-col>
          </b-row>
        </router-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    name: "Index",
  };
</script>

<style lang="scss" scoped>
  a {
    &:hover {
      text-decoration: none;
    }
  }
</style>
